import { render, staticRenderFns } from "./agenda-active-item-viewer-component.vue?vue&type=template&id=54ed343e&scoped=true"
import script from "./agenda-active-item-viewer-component.ts?vue&type=script&lang=ts&external"
export * from "./agenda-active-item-viewer-component.ts?vue&type=script&lang=ts&external"
import style0 from "./agenda-active-item-viewer-component.scss?vue&type=style&index=0&id=54ed343e&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54ed343e",
  null
  
)

export default component.exports